rdefine('app/clients/PropertyModal', ['backbone', 'text!clients/propmodal.html','app/formular/components/Tabs', 'text!clients/propmodaltab.html','text!clients/property-option-modal.html','app/components/SelectPicker'],
    function(Backbone, template, Tabs, tabTemplate,optTemplate, SelectPicker) {

    var optionModel = Backbone.Ribs.Model.extend({
        defaults:{
            names:{},
            order:0
        }
    });

    var propertyOptionView = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'row m-t-10',
        events:{
            "click .btn-danger":"removeOption"
        },
        bindings:{
            '.opt-value':{
                value:{
                    data:'',
                    events:'keyup change'
                }
            }
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(optTemplate)({order: this.model.get('order')}));
            this.bindings['.opt-value'].value.data = 'model.names.' + options.language;
            this.model.on("change:names."+options.language,function() {
                this.model.collection.pack();
            }.bind(this));
        },
        removeOption: function() {
            this.model.collection.remove(this.model);
        }
    });

    var PropModalLangTab = Backbone.Ribs.View.extend({
        bindings:{
            '.options-row':{
                toggle:{
                    data:'model.type',
                    processor:function(type) {
                        return type==="select";
                    }
                }
            },
            '.options-row-place':{
                collection:{
                    col:'options',
                    view:propertyOptionView
                }
            },
            'input.name-value':{

            }
        },
        events:{
            "click .remove-property":"removeProp",
            "click .add-option":"addOption"
        },
        orders:0,
        options:null,
        initialize:function (opts) {
            this.preventBindings();
            this.orders = opts.orders;
            this.options = opts.options;
            this.$el.html(Template7.compile(tabTemplate)());
            this.language  = opts.language;

            this.bindings['input.name-value'].value = {
                data:'model.name_' + opts.language,
                events:'change keyup'
            };

          /*  this.model.on("change:names",function(){

            }.bind(this));*/

            this.bindings['.options-row-place'].collection.view = function(options){
                options.language = opts.language;
                return new propertyOptionView(options);
            };

            this.applyBindings();
        },
        addOption: function() {
            this.options.add(new optionModel({
                names:{},
                order: this.orders++
            }));
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        modal:null,
        bindings:{
            '.modal-title':{
                text:{
                    data:'model.id',
                    processor:function(id) {
                        return id===0 ? LANGUAGE['clients.config.pmodal.title.add'] : LANGUAGE['clients.config.form.edit_property']
                    }
                }
            },
            '.save-button':{
                text:{
                    data:"model.id",
                    processor: function(id) {
                        return id===0 ? LANGUAGE['clients.config.form.add_property'] : LANGUAGE['basic.apply']
                    }
                }
            },
            '.property_required':{
                checked:'model.required'
            },
            '.prop_parent_group':{
                toggle:{
                    data:'model.type',
                    processor:function(type){
                        return type!=='group'
                    }
                }
            },
            '.property_visible':{
                checked:'model.visible'
            },
            '.prop_icon_field':{
                valueCustom:'model.icon'
            },
            '.property_public':{
                checked:'model.private'
            },
        },
        handlers:{
            customselect:{
                get: function ($el, value) {
                    $el.trigger('change');
                    if ($el.val() !== value) {
                        $el.find("option[selected]").removeAttr("selected");
                        $el.find("option[value="+value+"]").attr("selected","selected");
                        $el.val(value);
                    }
                    $el.selectpicker('refresh');
                },
                set: function ($el) {
                    $el.selectpicker('refresh');
                    return $el.val();
                }
            },
            valueCustom: {
                get: function ($el, value) {
                    if ($el.val() !== value) {
                        $el.val(value).trigger('change');
                        $el[0].fpp.refreshPicker();
                    }
                },
                set: function ($el) {
                    return $el.val();
                }
            }
        },
        events:{
            "click .save-button":"doSave"
        },
        orders:0,
        options:null,
        initialize: function(options) {
            this.preventBindings();
            this.$el.html(Template7.compile(template)());
            $("body").append(this.el);

            this.options = new Backbone.Ribs.Collection(this.model.get("options"),{ model: optionModel} );
            this.options.pack = function() {
                var options = [];
                for(var i=0;i<this.options.length;i++) {
                    options.push(this.options.models[i].attributes);
                }
                this.model.set('options', options);
                this.model.trigger('change');
            }.bind(this);
            this.options.on("add remove change",this.options.pack);

            this.langs=[];

            var tabs = _.clone([]);
            for(var i in options.languages) {

                var language = options.languages[i];
                this.model.on("change:name_"+language.lang.shortname,this.onNameChange.bind(this));
                this.langs.push(language.lang.shortname);
                tabs.push({
                    title: language.lang.name,
                    module: PropModalLangTab,
                    options:{
                        language:language.lang.shortname,
                        model: this.model,
                        orders: this.orders,
                        options: this.options
                    }
                });
            }
            this.optionsCollection = new Backbone.Ribs.Collection([
                {id:'string', value:LANGUAGE['clients.config.props.types.string']},
                {id:'number', value:LANGUAGE['clients.config.props.types.number']},
                {id:'textarea', value:LANGUAGE['clients.config.props.types.textarea']},
                {id:'select', value:LANGUAGE['clients.config.props.types.select']},
                {id:'email', value:LANGUAGE['clients.config.props.types.email']},
                {id:'phone', value:LANGUAGE['clients.config.props.types.phone']},
                {id:'date', value:LANGUAGE['clients.config.props.types.date']},
                {id:'profile_picture', value:LANGUAGE['clients.config.props.types.profile_picture']},
                {id:'group', value:LANGUAGE['clients.config.props.types.group']},
                {id:'address', value:LANGUAGE['clients.config.props.types.address']}
            ],{model: Backbone.Ribs.Model});

            this.GroupsCollection = new Backbone.Ribs.Collection([],{model:Backbone.Ribs.Model});


            new SelectPicker({el: this.$el.find('select')[0], collection: this.optionsCollection, model:this.model, field:'type'});
            new SelectPicker({el: this.$el.find('select')[1], collection: this.GroupsCollection, model:this.model, field:'parent_id'});
            this.tabs = new Tabs({el:this.$el.find('.language-tabs-place')[0], tabs:tabs, orders: this.orders});
            this.onsave = options.onsave;
            this.onupdate = options.onupdate;

            this.applyBindings();
        },
        onNameChange:function() {
            var s = {};
            for(var i in this.langs) {
                var lang = this.langs[i];
                s[lang] = this.model.get('name_'+lang,'');
            }
            this.model.set('names',s);
        },
        show:function(){
            this.$el.find('.modal').modal('show');
            var names = _.clone(this.model.get('names'));
            this.model.trigger('change:type');

            for(var i in this.langs) {
                var lang = this.langs[i];
                this.model.set('name_'+lang, '',{silent:true});
            }

            console.log('names', names);

            for(var key in names) {
                console.log('set',key, names[key]);
                this.model.set('name_'+key, names[key], {silent:true});
            }

            for(var i in this.langs) {
                var lang = this.langs[i];
                this.model.trigger('change:name_'+lang);
            }

            this.model.trigger('change:options');
            this.options.reset(this.model.get("options"));
        },
        hide:function(){
            this.$el.find('.modal').modal('hide')
        },
        doSave:function() {
            if(this.model.get('id')>0) {
                this.onupdate();
            }else {
                this.onsave();
            }
            this.hide();
        },
        resetGroup:function(groups) {
            var s = [{
                id:0,value:LANGUAGE['clients.config.props.group.none']
            }];
            for(var id in groups) {
                s.push({id:id,value: groups[id].names[CURRENT_LOCALE]});
            }
            console.log('aaa',s);
            this.GroupsCollection.reset(s);
        }
    });
});